// 引入 polyfill 解决 util._extend 弃用警告
import "./utils/polyfill.js";

// 初始化运行时主题（浅色/深色 + 可配置主色）
// 必须在 new Vue() 之前同步执行，避免刷新时闪白/闪黑
import { initTheme, setThemeMode, getThemeMode, setPrimaryColor, getTheme, resetTheme, toggleThemeMode } from "./utils/theme";
initTheme();

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import { lockState, syncLockSession, requiresLoginOnEntry, clearSystemLock } from "./utils/systemLock";
// 登录态校验：token 有效性判断 + 登录缓存清理
import { getToken, getLoginUser, hasPermissionInfo, hasLoginCache, isTokenValid, clearLoginCache, notifyLoginExpired } from "./utils/auth";

// ⚠⚠ 引入顺序至关重要：Element UI 的样式必须【先于】设计 token 载入。
// Element UI 的 $--color-primary 在 SCSS 编译期被内联为具体色值（不含 CSS 变量），
// 因此只能靠「后加载者胜」的层叠规则覆盖它。
// 之前 theme.scss 在第14 行、element-ui 在第 22 行 → token 被 Element 反超，
// 表现为「改了 --app-primary 但界面没变化」。
//
// element-theme-brand.css 是由 build-element-theme.js 生成的「品牌蓝版Element 样式」
//（把#409EFF 体系整体换算为 #2E5AA8，含 light-1..9 / dark-2 衍生色）。
// 有了它就不再依赖选择器覆盖去「赢」Element，这是最稳的方案。
import "./assets/element-theme-brand.css";
import "@/assets/ef/index.css";

// 引入设计 token（设计变量唯一权威来源 + 组件级微调 + 深色主题）
import "./assets/scss/theme.scss";

// 引入element UI（JS 侧；样式已由上面品牌主题替代官方 index.css）
import ElementUI from "element-ui";
import installTableFullValue from "./utils/tableFullValue";
installTableFullValue(ElementUI.Table);

// 引入分页器
import Pagination from "./components/Pagination.vue";
Vue.component(Pagination.name, Pagination);

import FileSaver from "file-saver";
import XLSX from "xlsx";
import KtButton from "@/permission/ktButton.vue";
import App from "./App";
// 引入路由
import router from "./router";
import { startOnlinePresence } from "./utils/onlinePresence";
import RouterTab from "vue-router-tab";
import "vue-router-tab/dist/lib/vue-router-tab.css";
Vue.use(RouterTab);
// 引入状态管理
import storeBtn from "./store/index.js";
// 引入icon
import "./assets/icon/iconfont.css";
//
import VueContextMenu from "vue-contextmenu";
import VueDraggableResizable from "vue-draggable-resizable";
import "vue-draggable-resizable/dist/VueDraggableResizable.css";
import vuescroll from "vuescroll"; //引入vuescroll
import "vuescroll/dist/vuescroll.css"; //引入vuescroll样式
Vue.component("VueDraggableResizable", VueDraggableResizable);
Vue.component("KtButton", KtButton);

// 引入echarts
import echarts from "echarts";
Vue.prototype.$echarts = echarts;
Vue.prototype.$FileSaver = FileSaver; //设置全局
Vue.prototype.$XLSX = XLSX; //设置全局
import axios from "axios";
Vue.prototype.$axios = axios;
Vue.config.productionTip = false;
// 使用element UI
Vue.use(ElementUI);
Vue.use(VueContextMenu);
Vue.use(vuescroll); //使用
import elTableInfiniteScroll from "el-table-infinite-scroll";

Vue.use(elTableInfiniteScroll);

import vueSeamlessScroll from "vue-seamless-scroll"; // 循环滚动
Vue.use(vueSeamlessScroll);

// 注册全局的组件
import libJs from "@/components/libs/index.js";
Vue.use(libJs);

import permissionStore from "./vuex/store.js";
import "./utils/directive/dialogDrag";
import moneyDirective from "./utils/directive/money.js";
Vue.directive(moneyDirective.name, moneyDirective);

Vue.prototype.$eventBus = new Vue(); // 全局事件
Vue.prototype.$permissionStore = permissionStore;

// 金额工具：负金额统一标红
import { isMoneyField, isNegativeMoney, moneyClass, moneyCellClass } from "./utils/money.js";
Vue.prototype.$isMoneyField = isMoneyField; // 判断字段名是否为金额字段
Vue.prototype.$isNegativeMoney = isNegativeMoney; // 判断值是否为负金额
Vue.prototype.$moneyClass = moneyClass; // 非表格处用：:class="$moneyClass(val, '字段名')"
Vue.prototype.$moneyCellClass = moneyCellClass; // el-table 用：:cell-class-name="$moneyCellClass"

// UI 语义工具：模板中用 $cls.pill("正常") / $cls.link() 等统一写法
import uiCls from "./utils/classNames.js";
Vue.prototype.$cls = uiCls;

Vue.config.productionTip = false;
// html导出pdf
import htmlToPdf from "./utils/pdf.js";
Vue.use(htmlToPdf);

import * as stateHandle from "./utils/stateHandle.js";
Vue.prototype.$stateHandle = stateHandle;

import loadmore from "./utils/loadmore.js";
Vue.directive(loadmore.name, loadmore.componentUpdated);

Vue.directive("permission", {
	inserted(el, binding) {
		// 假设用户权限存储在Vuex中
		const permissions = permissionStore.state.permission;
		// 判断用户是否拥有指定的权限
		if (!permissions[binding.value]) {
			el.parentNode && el.parentNode.removeChild(el); // 如果没有权限，则移除该元素
		}
	}
});

let historyList = []; //用于存储历史路由信息
// 路由拦截器
// 静默 vue-router 无害的导航中断错误（如快速切换菜单时“Navigation cancelled ... with a new navigation”、重复导航等）
function isHarmlessNavError(reason) {
	if (!reason) return false;
	const text = ((reason.message || "") + " " + (reason._name || "") + " " + (reason.name || "")).toLowerCase();
	return (
		text.indexOf("navigation cancelled") !== -1 ||
		text.indexOf("navigation aborted") !== -1 ||
		text.indexOf("redirected when going from") !== -1 ||
		text.indexOf("avoided redundant navigation") !== -1 ||
		text.indexOf("navigationduplicated") !== -1 ||
		text.indexOf("with a new navigation") !== -1
	);
}
window.addEventListener("unhandledrejection", (event) => {
	if (isHarmlessNavError(event && event.reason)) {
		event.preventDefault();
		event.stopImmediatePropagation && event.stopImmediatePropagation();
	}
});
// 兜底：捕获同步抛出的导航错误，避免控制台噪音
const _consoleError = console.error;
console.error = function (...args) {
	const first = args && args[0];
	if (first && (isHarmlessNavError(first) || (typeof first === "string" && first.toLowerCase().indexOf("navigation cancelled") !== -1))) {
		return;
	}
	return _consoleError.apply(console, args);
};

// 登录页（根路径 "/" 渲染的也是登录页）
const LOGIN_PATHS = ["/login", "/"];
// 登录成功后的默认落点
const HOME_PATH = "/exeIndex/mainIndex/workbench";
// 登录即可访问、不做菜单权限管控的页面
const NO_MENU_PERMISSION_PATHS = ["/exeIndex/mainIndex/workbench", "/system/message", "/system/usageGuide", "/401", "/404"];

router.beforeEach((to, from, next) => {
	if (requiresLoginOnEntry()) {
		clearLoginCache();
		clearSystemLock();
		return next({ path: "/login", replace: true });
	}
	syncLockSession();
	// Keep navigation blocked while locking within the current visit.
	if (lockState.locked && from.matched.length) return next(false);

	// 登录态 = token 有效 且 用户缓存（含菜单权限）完整
	const userdata = getLoginUser();
	const logged = isTokenValid() && hasPermissionInfo(userdata);

	// 允许直接访问登录页；本地 token 仍有效则不必再登录，直接进系统
	if (LOGIN_PATHS.indexOf(to.path) !== -1) {
		if (logged) {
			return next({ path: HOME_PATH });
		}
		// 缓存里还留着过期登录信息 → 清理并提示，避免脏缓存反复命中
		if (getToken()) {
			notifyLoginExpired();
		} else if (hasLoginCache()) {
			clearLoginCache();
		}
		return next();
	}

	// 其余所有页面都要求有效登录态：无 token 静默回登录页，token 已失效则提示后回登录页
	if (!logged) {
		if (getToken()) {
			notifyLoginExpired(); // 清登录缓存 + 提示「登录已过期」
		} else if (hasLoginCache()) {
			clearLoginCache(); // 清掉没有 token 的残缺缓存（如只剩 userdata）
		}
		return next({ path: "/login" });
	}

	// 登录即可访问、不受菜单权限管控的页面
	if (NO_MENU_PERMISSION_PATHS.indexOf(to.path) !== -1) {
		return next();
	}

	let hasPermission = false;
	userdata.permissionInfo.forEach((item) => {
		if (to.path === item.menuPath) {
			permissionStore.dispatch("SET_PERMISSION", item.btnOps);
			to.meta.title = item.menuName;
			to.meta.menuIcon = item.menuIcon;
			to.meta.menuColor = item.menuColor;
			to.meta.icon = item.menuIcon;
			hasPermission = true;
		}
	});

	if (hasPermission) {
		next();
	} else {
		// 检查路由是否存在
		const routeExists = router.options.routes.some((route) => {
			// 检查顶层路由
			if (route.path === to.path) return true;
			// 检查子路由
			if (route.children && route.children.some((child) => child.path === to.path)) return true;
			// 检查嵌套子路由
			if (route.children) {
				return route.children.some((child) => child.children && child.children.some((grandChild) => grandChild.path === to.path));
			}
			return false;
		});
		if (routeExists) {
			next({ path: "/401" });
		} else {
			next({ path: "/404" });
		}
	}
});

Vue.prototype.$checkBtnPermission = function (menuPath, btnCode) {
	let userdata = localStorage.getItem("userdata");
	if (userdata) {
		let btnPermission = JSON.parse(userdata).permissionInfo;
		let menu = btnPermission.filter((item) => item.menuPath == menuPath)[0];
		if (menu) {
			let btn = menu.btnOps.filter((item) => item.menuCode == btnCode)[0];
			if (btn) {
				return true;
			}
		}
	}
	return false;
};

// 主题能力挂到原型，任意组件内可用 this.$setThemeMode("dark") 等
Vue.prototype.$setThemeMode = setThemeMode;
Vue.prototype.$getThemeMode = getThemeMode;
Vue.prototype.$setPrimaryColor = setPrimaryColor;
Vue.prototype.$getTheme = getTheme;
Vue.prototype.$resetTheme = resetTheme;
Vue.prototype.$toggleThemeMode = toggleThemeMode;

startOnlinePresence(router);
new Vue({
	el: "#app",
	router,
	storeBtn, //使用storeBtn vuex状态管理
	components: {
		App
	},
	template: "<App/>",
	data: function () {
		return {
			// 空的实例放到根组件下，所有的子组件都能调用
			Bus: new Vue()
		};
	}
});
